var _path, _path2, _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 21.188V20.6156C9.75 20.4195 9.75 20.2234 9.7818 20.0326C9.8454 19.3701 9.8772 18.7023 9.9779 18.0451C10.0425 17.4808 10.2691 16.9474 10.6302 16.5091C10.9914 16.0709 11.4717 15.7465 12.0131 15.5752C12.6014 15.3632 13.2162 15.236 13.8204 15.0452C13.9125 15.0171 14.0104 15.0146 14.1038 15.0379C14.1972 15.0613 14.2824 15.1096 14.3504 15.1777C14.794 15.519 15.3443 15.6918 15.9033 15.6653C16.5495 15.6981 17.1823 15.4732 17.6629 15.0399C17.6816 15.0238 17.7037 15.0121 17.7276 15.0056C17.7515 14.9992 17.7765 14.9983 17.8007 15.0028C18.3784 15.1406 18.9561 15.2625 19.5232 15.4321C20.1234 15.5712 20.6679 15.8878 21.0857 16.3406C21.5035 16.7934 21.7753 17.3614 21.8659 17.9709C21.9772 18.644 22.009 19.333 22.0726 20.0167C22.0726 20.2181 22.0726 20.4248 22.1044 20.6315V21.1615C21.8055 21.5731 21.4033 21.8986 20.9383 22.1049C19.8586 22.5924 18.6976 22.8746 17.5145 22.937L16.7142 23.0006H15.1242L14.9175 22.9635C14.255 22.8893 13.5819 22.8522 12.9247 22.7303C11.7375 22.5183 10.5768 22.1685 9.75 21.188Z",
    fill: "#310048"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3479 7.5C16.6076 7.5424 16.8779 7.5742 17.127 7.6378C17.5496 7.72598 17.9399 7.92819 18.2557 8.2225C18.5715 8.51681 18.8007 8.89198 18.9184 9.30731C19.3136 10.5107 19.3247 11.8073 18.9502 13.0173C18.7632 13.6104 18.4317 14.1476 17.9856 14.5808C17.7155 14.8577 17.3915 15.0763 17.0338 15.2233C16.676 15.3703 16.2919 15.4426 15.9052 15.4356C15.5185 15.4287 15.1372 15.3427 14.785 15.1829C14.4327 15.0231 14.1169 14.793 13.8569 14.5066C13.2208 13.8673 12.8177 13.0331 12.7121 12.1375C12.593 11.227 12.6616 10.3017 12.9135 9.41861C13.043 8.92455 13.3206 8.48198 13.7091 8.15037C14.0976 7.81876 14.5782 7.61399 15.0865 7.5636L15.5211 7.5H16.3479Z",
    fill: "#310048"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_950_23250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.55553,
    y: 8.77051,
    width: 2.93474,
    height: 24.0908,
    transform: "rotate(-52.7987 5.55553 8.77051)",
    fill: "#310048"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99338,
    y: 8.71054,
    width: 2.30974,
    height: 23.4658,
    transform: "rotate(-52.7987 5.99338 8.71054)",
    stroke: "#EAE6ED",
    strokeWidth: 0.625
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 11.5625,
    stroke: "#310048",
    strokeWidth: 1.875
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_950_23250",
    x: 0.555529,
    y: 6.43262,
    width: 30.9631,
    height: 26.9033,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_950_23250"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_950_23250",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockUser);
export default __webpack_public_path__ + "static/media/block-user.8df3ff263685b7fd023897adcf6b7567.svg";
export { ForwardRef as ReactComponent };